module.exports = __webpack_public_path__ + "img/组 4.3b200df8.webp";